import React from "react";
import { Box, Grid, Link, Paper, Tooltip, Typography } from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import { STORAGE_BUCKET, IMG_PLACEHOLDER } from "../../common/constants";
import { Link as RouterLink } from "react-router-dom";
import ItemProgress from "./ItemProgress";

export default function KitchenItemSummary(props) {
  const { item, onProgressChange } = props;

  const image = item.images?.find(Boolean) || `${STORAGE_BUCKET}${IMG_PLACEHOLDER}`;
  const itemPosition = `${item.itemIndex + 1} of ${item.itemCount}`;
  const title = `${item.quantity || 1}x ${item.title || item.type}`;
  const itemUrl = `/production/tracker/order/${item.orderId}/item/${item.itemIndex}`;

  return (
    <Box my={2}>
      <Paper elevation={0}>
        <Box p={2}>
          <Grid container spacing={2} alignItems="center">
            <Grid item sm={3} xs={4}>
              <Link to={itemUrl} component={RouterLink} sx={{ display: "block" }}>
                <img
                  alt=""
                  src={image}
                  style={{ width: "100%", aspectRatio: "1", objectFit: "cover", display: "block" }}
                />
              </Link>
            </Grid>
            <Grid item sm={9} xs={8} zeroMinWidth>
              {/* The progress ring stays outside the link so its clicks and dialog don't navigate. */}
              <Link to={itemUrl} component={RouterLink} underline="none" color="inherit">
                <Typography variant="h6" noWrap title={title}>
                  {title}
                </Typography>
                {item.itemCount > 1 && (
                  <Tooltip title={`Item ${itemPosition} in this order`}>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
                    >
                      <LayersOutlinedIcon sx={{ fontSize: "1.1rem" }} />
                      {itemPosition}
                    </Typography>
                  </Tooltip>
                )}
              </Link>
              <Box mt={0.5} sx={{ display: "flex" }}>
                <ItemProgress
                  key={item.progress.step}
                  orderId={item.orderId}
                  item={item}
                  itemIndex={item.itemIndex}
                  progress={item.progress}
                  onChange={(data) => onProgressChange(item.orderId, data)}
                  size={20}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
}
